import { Card, Row } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

export const PrintCouponBanner = () => {
  return (
    <Card className="disclamer h-100">
      <Row className="align-start">
        <InfoCircleOutlined className="mr-2 text-md title disclamer-icon" />
        <div className="disclamer-body">
          <p className="my-0 text-sm title">
            Starting in 2027, we will no longer send out payment coupons or
            1098s. You can print them here at any time. If you are unable to
            print, contact our office.
          </p>
        </div>
      </Row>
    </Card>
  );
};
